// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { ItemDetail } from './item-detail';
import { JoDetail } from './jo-detail';
import { PoDetail } from './po-detail';
import { ProductEOQ } from './product-eoq';
import { ProductFeatureChoice } from './product-feature-choice';
import { ProductReplacement } from './product-replacement';
import { ProductType } from './product-type';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import _ from "lodash";
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Product extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getFirstFeatureChoice() {
    return _.first(this.getProductFeatureChoicesInDisplayOrder()).featureChoice;
  }

  getFeatureChoicesExtract() {
    // Sort featureChoices by productTypeFeatureMaps.displayOrder if available otherwise by featureName
    const ptfms = this.productType?.productTypeFeatureMaps ?? [];
    var pfcs = [];
    if (ptfms.length > 0) {
      pfcs = this.getProductFeatureChoicesInDisplayOrder();
    } else {
      pfcs = _.sortBy(this.productFeatureChoices, (x) => x.featureChoice?.feature?.getDisplayName() || x.featureChoice.displayOrder);
    }

    return pfcs.map((pfc) => pfc.featureChoice.choiceValue).join("; ");
  }

  // for binding
  get featureChoicesExtract() {
    return this.getFeatureChoicesExtract();
  }

  // requires that productType.productTypeFeatures have been queried
  getProductFeatureChoicesInDisplayOrder() {
    const featureIdOrder = _.orderBy(this.productType.productTypeFeatureMaps, (x) => x.displayOrder).map((x) => x.featureId);
    const r = _.orderBy(this.productFeatureChoices, (x) => featureIdOrder.indexOf(x.featureChoice.featureId));
    return r;
  }

  // Only used for bar codes.
  getBarcodeFeatureChoicesExtract() {
    return this.productFeatureChoices
      .map((pfc) => pfc.featureChoice?.feature?.getDisplayName() + ": " + pfc.featureChoice.choiceValue)
      .join(";");
  }

  // Requires that all products and productFeatureChoices have been queries for this product's productType
  getReorderProduct() {
    if (!this.productType.allowReorderFeatureChoices) {
      return this;
    }
    const reorderFeatureChoiceIds = this.productFeatureChoices.map(
      (pfc) => pfc.featureChoice.reorderFeatureChoiceId ?? pfc.featureChoiceId
    );
    // find a matching product
    const reorderProduct = this.productType.products.find(
      (p) => p != this && p.productFeatureChoices.every((pfc) => reorderFeatureChoiceIds.includes(pfc.featureChoiceId))
    );
    if (reorderProduct != null) {
      return reorderProduct;
    } else {
      return this;
    }
  }

  // returns the sort order of this product within others of the same type
  // requires that productType.productTypeFeatures.featureChoice have all been fetched.
  getSortOrder() {
    const pt = this.productType;
    if (pt == null) return 0;
    // find ptf with lowest display order
    const ptf = _.first(_.sortBy(pt.productTypeFeatureMaps, (ptf) => ptf.displayOrder));
    // find featureChoice for this feature
    const pfc = this.productFeatureChoices.find((pfc) => pfc.featureChoice.featureId == ptf?.featureId);
    // this is the feature ww will sort on.
    // TODO: later we can add multi-feature sort - instead of just first feature sort.
    return pfc?.featureChoice.displayOrder;
  }

  // requires that productType.productTypeFeatureMaps have been queried
  getOrderedProductFeatureChoices() {
    const featureIdOrder = _.orderBy(this.productType.productTypeFeatureMaps, (x) => x.displayOrder).map((x) => x.featureId);
    const r = _.orderBy(this.productFeatureChoices, (x) => featureIdOrder.indexOf(x.featureChoice.featureId));
    return r;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** DateTimeOffset */
  modTs!: Date;
  /** String(4) */
  modUserInit!: string;
  /** Int32 */
  pAD_KEY?: number;
  /** Int32 FK productType */
  productTypeId!: number;
  /** Binary */
  rowVersion!: any;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK productId */
  itemDetails!: ItemDetail[];
  /** Inv FK productId */
  joDetails!: JoDetail[];
  /** Inv FK origProductId */
  poDetailOrigProducts!: PoDetail[];
  /** Inv FK productId */
  poDetailProducts!: PoDetail[];
  /** Inv FK productId */
  productEOQ!: ProductEOQ;
  /** Inv FK productId */
  productFeatureChoices!: ProductFeatureChoice[];
  /** Inv FK newProductId */
  productReplacementNewProducts!: ProductReplacement[];
  /** Inv FK oldProductId */
  productReplacementOldProduct!: ProductReplacement;
  /** FK productTypeId */
  productType!: ProductType;
}

